/**
 * @fileoverview Resolve one account-apps-ui string: consumer `t` → English default.
 * @module @puffin-core/account-apps-ui/strings/resolveString
 *
 * Bound from the ONE shared implementation in the React-free `@puffin-core/i18n-bootstrap/strings-kit`
 * subpath, which treats a nullish, empty or ECHOED-KEY translation as missing — the last is what
 * react-i18next returns for an unregistered key, so an unwired app renders English, never a raw
 * key. Part of the leaf-only `strings/` subtree `@puffin-core/i18n-namespaces` imports at app boot.
 */

import { createStringResolver } from '@puffin-core/i18n-bootstrap/strings-kit';

import { ACCOUNT_APPS_UI_EN } from './en.js';

/**
 * @param {((key: string, params?: Object) => string|undefined|null)|undefined|null} t
 * @param {string} key
 * @param {Object} [params]
 * @returns {string|undefined} The resolved string, or `undefined` for a key the bundle lacks.
 */
export const resolveString = createStringResolver(ACCOUNT_APPS_UI_EN);
